import { propsCallback } from "./blueprint";
export function debug(callback) {
    if (callback === void 0) { callback = console.log; }
    return {
        instanceCallbacks: [
            propsCallback(function (props) {
                callback(props);
                return props;
            }),
        ],
    };
}
export default debug;

//# sourceMappingURL=debug.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/debug.js
// module id = 44
// module chunks = 0